import { useEffect, useState } from "react";
import api from "./api";

let cache = null;
let pending = null;
const listeners = new Set();

async function fetchOnce() {
  if (cache) return cache;
  if (pending) return pending;
  pending = api
    .get("/site-settings")
    .then((r) => {
      cache = r.data || {};
      pending = null;
      listeners.forEach((cb) => cb(cache));
      return cache;
    })
    .catch(() => {
      cache = {};
      pending = null;
      return cache;
    });
  return pending;
}

/**
 * Hook: odczyt konfiguracji widoczności ze `/api/site-settings`.
 * Fail-open — brak klucza = element widoczny.
 */
export function useSiteSettings() {
  const [settings, setSettings] = useState(cache);
  useEffect(() => {
    let alive = true;
    const cb = (v) => alive && setSettings(v);
    listeners.add(cb);
    fetchOnce().then((v) => alive && setSettings(v));
    return () => {
      alive = false;
      listeners.delete(cb);
    };
  }, []);
  return settings;
}

/** Pomocnicze: czy dana strona jest widoczna? Fail-open. */
export function isPageVisible(settings, key) {
  if (!settings || !settings.pages) return true;
  return settings.pages[key] !== false;
}

/** Pomocnicze: czy dany widget na stronie głównej jest widoczny? Fail-open. */
export function isWidgetVisible(settings, key) {
  if (!settings || !settings.widgets) return true;
  return settings.widgets[key] !== false;
}
